import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';

domReady(async () => {
	const selector = `.${manifest.blockJsClass}`;
	const elements = document.querySelectorAll(selector);

	if (!elements.length) {
		return;
	}

	const { CodeBlockResizer } = await import('./code-block-resizer');

	elements.forEach((item) => {
		new CodeBlockResizer({
			codeBlock: item,
			resizer: item.querySelector(`${selector}-resizer`),
		}).init();
	});
});
